import { TextInput } from '@mantine/core';
import useWhoAmI from '@/hooks/useWhoAmI';
import { isNotEmpty, useForm } from '@mantine/form';
import EditUserFormBase from './EditUserFormBase';
import { UpdatePatientInput } from '@/lib/graphql/types';
import { useEffect, useRef } from 'react';

interface EditFormDefaultProps {
  label: string;
  valueName: keyof UpdatePatientInput;
  onClose: () => void;
}

const EditFormDefault = ({
  label,
  valueName,
  onClose,
}: EditFormDefaultProps) => {
  const { user, isLoading } = useWhoAmI();

  const isInitialValuesSet = useRef(false);

  const form = useForm<UpdatePatientInput>({
    initialValues: {
      [valueName]: user?.[valueName] ? user[valueName] : '',
    },
    validate: {
      [valueName]: isNotEmpty(`${label} is required`),
    },
  });

  useEffect(() => {
    if (user && user[valueName] && !isLoading && !isInitialValuesSet.current) {
      form.setValues({
        [valueName]: user[valueName],
      });
      isInitialValuesSet.current = true;
    }
  }, [user, form, valueName, isLoading]);

  return (
    <EditUserFormBase form={form} onClose={onClose}>
      <TextInput placeholder={label} {...form.getInputProps(valueName)} />
    </EditUserFormBase>
  );
};

export default EditFormDefault;
